import { createSlice } from '@reduxjs/toolkit';

const rateTypeSlice = createSlice({
    name: 'rateTypes',
    initialState: [],
    reducers: {
        setRateTypes: (_state, action) => action.payload,
        addRateType: (state, action) => {
            state.push(action.payload);
        },
        updateRateType: (state, action) => {
            const idx = state.findIndex((r) => r.id == action.payload.id);
            if (idx !== -1) state[idx] = action.payload;
        },
        // Grid row ids are often strings; API rows use numeric ids — use loose equality.
        deleteRateType: (state, action) => state.filter((r) => r.id != action.payload),
    },
});

export const { setRateTypes, addRateType, updateRateType, deleteRateType } = rateTypeSlice.actions;
export default rateTypeSlice.reducer;
